import { render, staticRenderFns } from "./GroupPartCard.vue?vue&type=template&id=16d6b98e&"
import script from "./GroupPartCard.vue?vue&type=script&lang=js&"
export * from "./GroupPartCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports